<template>
	<div class="personal">
		<el-container>
		  <el-header class='personal-header'>
			  <div>{{$t('other.a406')}}-{{$t('other.a1984')}}</div>

			  <div><el-button size="mini" type="primary" @click="back()">{{$t('other.a1279')}}</el-button></div>
		  </el-header>
		  <el-container>
		    <el-aside class='personal-aside'>
				
				<ul style="margin-top: 20px;">
					<!-- <li :class=" {'active' :isactive === '/personal-info','btn-item':true}" @click="topage(1)"><i class="iconfont icon-gerenzhongxin icon"></i>个 人 信 息</li> -->
					<li :class=" {'active' :isactive === '/personal-account','btn-item':true}" @click="topage(2)"><i class="iconfont icon-gerenzhongxin icon"></i>{{$t('other.a1985')}}</li>
					<li :class=" {'active' :isactive === '/personal-address','btn-item':true}" @click="topage(4)"><i class="iconfont icon-gerenzhongxin icon"></i>{{$t('other.a1986')}} </li>
					<!-- <li :class=" {'active' :isactive === 3,'btn-item':true}" @click="topage(3)"><i class="iconfont icon-gerenzhongxin icon"></i>第 三 方 帐 号</li> -->
					
				</ul>

			</el-aside>
		    <el-main class='personal-main'>
				<router-view    />
				
			</el-main>
		  </el-container>
		</el-container>
		
	</div>
</template>

<script>
	export default {
		data(){
			return{
				isactive:this.$route.path
			}
		},
		methods:{
			topage(num){
				
				
				if(num === 1) {
					this.$router.push('/personal-info')
					this.isactive=this.$route.path
				}else if(num === 2){
					
					this.$router.push({
						path:'/personal-account',
						query:{
							key:this.$route.query.key,
							from:this.$route.query.from,
						}
					})
					this.isactive=this.$route.path
				}else if(num == 4){
					this.$router.push({
						path:'/personal-address',
						query:{
							key:this.$route.query.key,
							from:this.$route.query.from,
						}
					})
					this.isactive=this.$route.path
				}
				
				console.log(this.$route.path)
			},

			back(){
				this.$router.push({
					path:this.$route.query.from
				})
			}
		}
	}
</script>

<style scoped>
	
	.personal{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(50,50,50,.1);
	
		
	}

	.personal-header{
		height: 50px!important;
		background-color: #fff;
		line-height: 50px;
		display: flex;
		justify-content: space-between;
		font-size: 20px;
		color:#2589ff!important;
	}
	.personal-aside{
		box-sizing: border-box;
		width: 15%!important;
		
		border-radius: 10px;
		margin: 10px;
		background-color: #fff;
	}
	.personal-main{
		box-sizing: border-box;
		border-radius: 10px;
		height: 100vh;
		margin: 10px;
		background-color: #fff;
	}
	.personal .btn-item{
		font-size: 16px;
		color: #595961;
		width: 100%;
		text-align: left;
		height: 60px;
		line-height: 60px;
		cursor: pointer;
		padding-left: 15px;
	}
	
	.personal .btn-item:hover{
		color: #2589ff;
	}
	.personal .icon{
		padding: 0 10px;
		font-size: 20px;
	}
	.active{
		color: #2589ff!important;
	}
	
</style>
